import React from "react";
import PropTypes from "prop-types";

export class LocationSearch extends React.Component {
  getLocationName(data) {
    let name1 = data.split(" [");
    return name1[0].toLowerCase();
  }

  getSiteId(data) {
    return data.match(/^.*?\([^\d]*(\d+)[^\d]*\)$/)[1];
  }

  render() {
    let locations = Object.entries(this.props.locations);
    return (
      <div className="modal fade" id="select-site" tabIndex="-1" role="dialog" aria-labelledby="SelectSite">
        <div className="modal-dialog react" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="SelectSite">
                Select Site
              </h4>
              <input type="text" className="search-query form-control filter-sites-input" placeholder="Filter" />
              <span className=" glyphicon glyphicon-search"></span>
            </div>

            <div className="modal-body">
              <ul className="sites">
                {this.props.allSitesLink !== "" ? (
                  <span data-url={this.props.allSitesLink} className="mindbody-site-link">
                    <li onClick={() => window.location.replace(this.props.allSitesLink)}>All Sites</li>
                  </span>
                ) : (
                  ""
                )}

                {locations.map((loc, index) => {
                  return (
                    <span key={index} data-url={loc[1]} className="mindbody-site-link">
                      <li
                        onClick={() => window.location.replace(loc[1])}
                        className=" mindbody-site"
                        data-site-id={this.getSiteId(loc[0])}
                        data-site-name={`${this.getLocationName(loc[0])} ${this.getSiteId(loc[0])}`}
                      >
                        {loc[0]}
                      </li>
                    </span>
                  );
                })}
              </ul>
            </div>
            <div className="modal-footer">
              <button type="button" className="link" data-dismiss="modal">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LocationSearch.propTypes = {
  allSitesLink: PropTypes.string,
  locations: PropTypes.object
};

export default LocationSearch;
